import { useNavigate, useParams } from "react-router-dom";
import Sqids from "sqids";

// FIXED: Every character in this alphabet appears exactly once (62 total characters)
const UNIQUE_ALPHABET = "FxM07T1DJW3S2489bcdefghiklnoopqrstuvwxyzABCEGHIKLNOPQRSTUVWXYZ";

// Remove duplicate characters programmatically to guarantee uniqueness:
const sanitizedAlphabet = Array.from(new Set(UNIQUE_ALPHABET)).join("");

const sqids = new Sqids({
  minLength: 6,
  alphabet: sanitizedAlphabet,
});

export const encodeId = (num) => {
  const parsed = Number(num);
  if (isNaN(parsed) || num === null || num === undefined) return "";
  return sqids.encode([parsed]);
};

export const decodeId = (str) => {
  if (!str) return null;
  const decoded = sqids.decode(str);
  return decoded.length > 0 ? decoded[0] : null;
};

// Hook to decode route parameters automatically
export function useDecodedParams(paramName = "id") {
  const params = useParams();
  const rawValue = params[paramName];
  return decodeId(rawValue);
}

// Hook to navigate using encoded IDs automatically
export function useEncodedNavigate() {
  const navigate = useNavigate();

  return (path, id, options) => {
    if (id !== undefined && id !== null) {
      const encoded = encodeId(id);
      navigate(`${path}/${encoded}`, options);
    } else {
      navigate(path, options);
    }
  };
}